import { render } from "./CabinetInfo.vue?vue&type=template&id=b6f1b326"
import script from "./CabinetInfo.vue?vue&type=script&lang=js"
export * from "./CabinetInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__